import React, { useState, useEffect } from "react";
import * as StateLib from "@/Utils/StateLib";
import { Globals } from "@coreapp/CoreApp/Globals";
import { QOnRampWidgetRFC } from "@coreapp/CoreApp/QOnRampWidgetRFC";

const OnRampBanner = () => {
  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let retryTimer = null;

    const tryFetch = async (retriesLeft = 10) => {
      if (cancelled) return;

      if (sessionStorage.getItem("onramp_unavailable")) return;

      const wsMgr = StateLib.GetWSMgr();
      const widgetMgr = wsMgr?.GetWidgetMgr();

      if (!widgetMgr || widgetMgr.GetWidgetState("onramp") !== "ready") {
        if (retriesLeft > 0) {
          retryTimer = setTimeout(() => tryFetch(retriesLeft - 1), 1000);
        }
        return;
      }

      try {
        const rfc = new QOnRampWidgetRFC();
        rfc.InitRFC();
        rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), wsMgr.GetUserEmail());
        const responsePromise = rfc.GetPromise();
        Globals._rfcMgr?.QueueRFC(rfc);
        const response = await responsePromise;
        if (cancelled) return;
        const result = JSON.parse(response);

        if (!result.onramp_available) {
          sessionStorage.setItem("onramp_unavailable", "1");
          return;
        }
        if (
          !result.data?.percent_complete ||
          !result.data?.days_remaining ||
          !result.data?.project_link
        )
          return;

        const pct = Number(result.data.percent_complete);
        const days = Number(result.data.days_remaining);

        if (pct === 100 || days <= 0) return;

        setBannerData(result.data);
      } catch (error) {
        console.error("[OnRampBanner]", error);
      }
    };

    tryFetch();

    return () => {
      cancelled = true;
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, []);

  if (!bannerData) return null;

  const { percent_complete, days_remaining, project_link, project_name, customer_logo } =
    bannerData;

  return (
    <div
      data-testid="onramp-banner"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        padding: "6px 14px",
        fontSize: "13px",
        color: "#333",
        minWidth: 0,
        overflow: "hidden",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        border: "1px solid #e0e0e0",
        marginLeft: "8px"
      }}
    >
      {customer_logo && (
        <img
          src={customer_logo}
          alt=""
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            objectFit: "contain",
            flexShrink: 0
          }}
        />
      )}
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        <strong>{project_name}</strong> is <strong>{percent_complete}%</strong> complete with{" "}
        <strong>{days_remaining}</strong> {Number(days_remaining) === 1 ? "day" : "days"} to go!
      </span>
      <a
        href={project_link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#7c3aed",
          fontWeight: 600,
          textDecoration: "none",
          marginLeft: "4px",
          flexShrink: 0
        }}
      >
        Keep going &#x2197;
      </a>
    </div>
  );
};

export default OnRampBanner;
